import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import queryString from 'query-string';

import Loader from '../utils/Loader';

import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../shared/vars';

import '../../css/pagination.css';
import '../../css/searchbar.css';

class Searchbar extends Component {
    constructor(props) {
        super(props);

        const query = !!props.location ? queryString.parse(props.location.search) : {};
        let pg = !!query.pg ? query.pg : '';
        const q = !!query.q ? query.q : '';
        const sort = !!query.sort ? query.sort : '';
        const dir = !!query.dir ? query.dir : '';

        if (pg < 0) pg = 0;

        this.state = {
            isLoading: false,
            errors: null,
            data: null,
            q: !!q ? q : '',
            sort: sort,
            sort_order: dir,
            pageCount: 8,
            page: pg ? parseInt(pg, 0) : 0,
            pushState: !!this.props.pushState ? this.props.pushState : false,
        };
    }

    componentDidMount() {
        if (!!this.props.onRef) this.props.onRef(this);
        this.search();
    }

    componentWillUnmount() {
        if (!!this.props.onRef) this.props.onRef(undefined);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const prevQuery = !!this.props.location
            ? queryString.parse(this.props.location.search)
            : {};
        const nextQuery = !!nextProps.location
            ? queryString.parse(nextProps.location.search)
            : {};

        const prevSort = !!prevQuery.sort ? prevQuery.sort : '';
        const nextSort = !!nextQuery.sort ? nextQuery.sort : '';

        const prevDir = !!prevQuery.dir ? prevQuery.dir : '';
        const nextDir = !!nextQuery.dir ? nextQuery.dir : '';

        const prevPg = !!prevQuery.pg ? prevQuery.pg : '';
        let nextPg = !!nextQuery.pg ? nextQuery.pg : '';

        const prevQ = !!prevQuery.q ? prevQuery.q : '';
        const nextQ = !!nextQuery.q ? nextQuery.q : '';

        if (nextPg < 0) nextPg = 0;

        if (
            prevQ !== nextQ ||
            prevPg !== nextPg ||
            prevSort !== nextSort ||
            prevDir !== nextDir
        ) {
            this.setState(
                {
                    q: !!nextQ ? nextQ : '',
                    page: !!nextPg ? parseInt(nextPg, 0) : 0,
                    sort: !!nextSort ? nextSort : '',
                    sort_order: !!nextDir ? nextDir : '',
                },
                () => this.search()
            );
        }
    }

    search() {
        this.setState({ isLoading: true });

        const apiEndpoint = this.props.searchEndpoint;
        const params = {
            q: this.state.q,
            pg: this.state.page + 1,
            order_by: this.state.sort,
            sort_order: this.state.sort_order,
            access_type: this.props.userType === 'admin' ? 'admin' : 'user',
        };

        if (!!this.props.params) {
            Object.keys(this.props.params).forEach((key) => {
                params[key] = this.props.params[key];
            });
        }

        const userToken = this.props.user ? this.props.user.token : null;

        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };
        // if (this.props.userType === "admin") {
        AUTH_HEADER.Authorization += ':Bearer ' + userToken;
        // }

        // console.log(params);
        // console.log(this.props.user.token);

        return axios
            .get(REACT_APP_API_URL + apiEndpoint, {
                headers: AUTH_HEADER,
                params: params,
            })
            .then((response) => {
                if (
                    response.status !== 200 ||
                    (response.data.status && response.data.status !== 200)
                ) {
                    this.setState({ isLoading: false, error: response.data.message });
                } else {
                    let responseData =
                        this.props.userType === 'admin'
                            ? { ...response.data }
                            : { ...response.data.items };
                    // if (this.props.userType === "customer") {
                    // 	this.setState({
                    // 		isLoading: false,
                    // 		data: {
                    // 			...responseData,
                    // 			items: responseData.orders
                    // 		}
                    // 	});
                    // 	return;
                    // }

                    this.setState({
                        isLoading: false,
                        data: { items: responseData, ...response.data },
                    });
                }
            })
            .catch((err) => {
                this.setState({
                    isLoading: false,
                    error: err.response.data.errors
                        ? err.response.data.errors
                        : err.response.data.message,
                });
            });
    }

    // ===================================================================================
    //  HANDLE CHANGES
    // ===================================================================================
    handlePaginationChange(data) {
        // The page number selected
        const selected = data.selected;

        // Get any other query objects
        let queryObj = {};
        const query = !!this.props.location
            ? queryString.parse(this.props.location.search)
            : {};
        const q = !!query.q ? query.q : '';
        if (!!q) queryObj.q = q;

        const sort = !!query.sort ? query.sort : '';
        if (!!sort) queryObj.sort = sort;

        const dir = !!query.dir ? query.dir : '';
        if (!!dir) queryObj.dir = dir;

        queryObj.pg = selected;

        // Make a valid url string (pg=2&q=cow, etc)
        const qs = queryString.stringify(queryObj);

        // Push to history.  UNSAFE_componentWillReceiveProps() will take care of triggering the search
        this.props.history.push('?' + qs);
    }

    handleKeyPress(e) {
        if (e.key === 'Enter') {
            const query = !!this.props.location
                ? queryString.parse(this.props.location.search)
                : {};
            const sort = !!query.sort ? query.sort : '';
            const dir = !!query.dir ? query.dir : '';

            let queryObj = {};
            if (!!sort) queryObj.sort = sort;
            if (!!dir) queryObj.dir = dir;

            // console.log(this.state.q)

            queryObj.q = this.state.q;

            queryObj = queryString.stringify(queryObj);

            this.props.history.push('?' + queryObj);
        }
    }

    handleInputChange(e) {
        this.setState({
            q: e.target.value,
        });
    }

    renderTable() {
        // Component passed in that displays search results
        const startPosition = this.state.data
            ? this.state.data.items_per_page * (this.state.data.current_page - 1)
            : 0;
        const SearchTable = this.props.component;

        // Send items to search listing with the index specified by the props, or simply the default 'items'
        const itemPropName = !!this.props.itemsIndex ? this.props.itemsIndex : 'items';
        let itemProp = {};
        itemProp[itemPropName] = this.state.data.items;

        return (
            <div className="search-listing">
                <SearchTable
                    {...itemProp}
                    startPosition={startPosition}
                    basePath={this.props.location.pathname}
                    {...this.props}
                />
            </div>
        );
    }

    render() {
        // console.log(this.state.page)
        return (
            <div>
                <div className="listing padded-listing">
                    <div className="input-wrapper">
                        <input
                            type="text"
                            name="search"
                            placeholder={
                                this.props.placeholder ? this.props.placeholder : 'Search'
                            }
                            value={this.state.q}
                            onKeyPress={(e) => this.handleKeyPress(e)}
                            onChange={(e) => this.handleInputChange(e)}
                            disabled={this.props.disabled}
                            autoFocus
                        />
                        <button
                            className="search-btn icon-search"
                            disabled={this.props.disabled}
                            onClick={() => this.search()}
                        />
                    </div>
                </div>

                {this.props.content && <div>{this.props.content}</div>}

                {this.state.isLoading ? (
                    <Loader />
                ) : // Show errors
                this.state.errors ? (
                    <div className="error">
                        {Object.keys(this.state.error).map((key) => (
                            <span key={key}>{this.state.error[key]}</span>
                        ))}
                    </div>
                ) : (
                    // Show search results
                    this.state.data !== null &&
                    (this.state.data.total_pages > 1 && !this.props.disabled ? (
                        <div>
                            <ReactPaginate
                                previousLabel={''}
                                previousLinkClassName={'icon-previous'}
                                nextLabel={''}
                                nextLinkClassName={'icon-next'}
                                breakLabel={<a href="">...</a>}
                                breakClassName={'break-me'}
                                pageCount={this.state.data.total_pages}
                                disableInitialCallback={true}
                                initialPage={this.state.page}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={4}
                                onPageChange={this.handlePaginationChange.bind(this)}
                                containerClassName={'pagination'}
                                subContainerClassName={'pages pagination'}
                                activeClassName={'active'}
                            />
                            {this.renderTable()}
                        </div>
                    ) : (
                        this.renderTable()
                    ))
                )}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user[ownProps.userType],
    };
};

export default withRouter(connect(mapStateToProps)(Searchbar));



// WEBPACK FOOTER //
// ./src/components/utils/Searchbar.js